import Api from '@/services/Api'
/* eslint-disable */
import axios from "axios";

const axiosInstanceaqua = axios.create({
  baseURL: "https://agriedge.ca/irrig/",
});

export default 
{  deleteNode(_id) {
  return new Promise(async (resolve, reject) => {
    try {

      console.log("hereeeeee::::");
      const response = await  Api().delete(`/Home/deleteNode/${_id}`);
      

      if (response.status === 200) {
        // Node deleted successfully
        resolve(true);
      } else {
        resolve(false);
      }
    } catch (error) {
      // Handle any errors that may occur during the deletion
      console.error('Error deleting node:', error);
      reject(error);
    }
  });
}, 
  addnewone(Node) {
    return new Promise((resolve, reject) => {
      Api()
        .post('/Home/addnewone', Node)
        .then(res => {
          resolve(res.data)
        })
        .catch(err => reject(err))
    })
  },
  getNodes() {
    return new Promise((resolve, reject) => {
      Api()
        .post('/Home/getNodes',{id_admin:localStorage.getItem("authToken")})
        .then(res => {
          resolve(res.data)
        })
        .catch(err => reject(err))
    })
  },
  getNodesAquaedge() {
    return new Promise((resolve, reject) => {
      axiosInstanceaqua
        .get("/Home/getNodesApp/DQRd8rRrG2Tzl6p2i56Fxzqp2q42")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => reject(err));
    });
  },
  // edit poly in node
  editPolynode(id, details) {
    return new Promise((resolve, reject) => {
      axiosInstanceaqua
        .post("/Home/editenode/", { id: id, details: details })
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  
  getnodedata(id, dates ,datee ) {
    return new Promise((resolve, reject) => {
      Api()
        .get(`/Home/getnodeData/${id}/${dates}/${datee}`)
        .then(data => 
        {
            resolve(data);
        })
        .catch(err => reject(err))
    })
  },
  getNodeDetails(id) {
    return new Promise((resolve, reject) => {
      Api().get(`/Home/getNodedetails/${id}`)
        .then((res) => {
          resolve(res.data)
        })
        .catch(err => reject(err))
    })
  },
  get_calcul(S1, S4, bool_hamza) {

    return new Promise((resolve, reject) => {
      Api().get(`/Home/correct_meteo/${S1}/${S4}/${bool_hamza}`)
        .then((data) => {
          resolve(data.data)
        })
        .catch(err => reject(err))
    })
  },
  getET0(idParcel, dated, datef) {
    return new Promise((resolve, reject) => {
      Api()
        .get(`/Home/eto_node/${idParcel}/${dated}/${datef}`)
        .then((data) => {
          console.log("==================");
          console.log(data.data);
          resolve(data.data);
        })
        .catch((err) => reject(err));
    });
  },

  getSoilMoisture(id, year, month) 
  {
    return new Promise((resolve, reject) => {
      // Build the base URL including the ID
      let url = `/Home/getImageSatelliteDates/${id}`;
  
      // Initialize parameters array
      const params = [];
  
      // Add year and month to parameters if provided
      if (year) params.push(`year=${year}`);
      if (month) params.push(`month=${month}`);
  
      // Concatenate all parameters with '&' and prepend a '?' if there are any parameters
      if (params.length) url += `?${params.join('&')}`;
  
      // Make the GET request using the constructed URL
      Api()
        .get(url)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => reject(error));
    });
  },
  
  

  getWeatherData(lat, long) {
    return new Promise((resolve, reject) => {
      Api().get(`/Home/getWeatherData/${lat}/${long}`)
        .then((data) => {
          resolve(data.data)
        })
        .catch(err => reject(err))
    })
  },
  
  export_data(id, start, end , value_check,nbr_port,prf,p1,p2,p3,p4,p5,p6) {
    return new Promise((resolve, reject) => {
      Api()
        .post('/Home/getnodeData/', {id: id, start: start, end: end , value_check:value_check,nbr_port:nbr_port,prf:prf,p1:p1,p2:p2,p3:p3,p4:p4,p5:p5,p6:p6})
        .then(data => 
        {
          resolve(data)
        })
        .catch(err => reject(err))
    })
  },
  check_data(id, start, end , value_check) {
    return new Promise((resolve, reject) => {
      Api()
        .post('/Home/checkData/', { id: id, start: start, end: end , value_check:value_check})
        .then(data => 
        {
          resolve(data)
        })
        .catch(err => reject(err))
    })
  },
  download(id) {
    return new Promise((resolve, reject) => {
      Api()
        .get(`/Home/nodefile/${id}`)
        .then((res) => {
          resolve(res)
        })
        .catch(err => reject(err))
    })
  },
  editnode(id, details) {
    return new Promise((resolve, reject) => {
      Api()
        .post('/Home/editenode/', { id: id, details: details })
        .then(data => {
          resolve(data)
        })
        .catch(err => reject(err))
    })
  },
  edit_on_off(details, id) {
    console.log("========================> : " + details);
    return new Promise((resolve, reject) => {
      Api()
        .post("/Home/edit_on_off/", { details: details, id_node: id })
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  sensor(id) {
    
    return new Promise((resolve, reject) => {
      Api()
        .post('/Home/sensor_historique',{id:id})
        .then(res => {
          resolve(res.data)
        })
        .catch(err => reject(err))
    })
  },
  sensor_by_date(id,start,end) {
    return new Promise((resolve, reject) => {
      Api()
        .post('/Home/sensor_get_by_dates',{id:id,start:start,end:end})
        .then(res => { 
          resolve(res.data)
        })
        .catch(err => reject(err))
    })
  },
  sensor_get_latest(id) {
    return new Promise((resolve, reject) => {
      Api()
        .post('/Home/sensor_get_latest',{id:id})
        .then(res => { 
          resolve(res.data)
        })
        .catch(err => reject(err))
    })
  },
  getLoraData(startDate, endDate, waterMeterId) {
 
 
return new Promise((resolve, reject) => {
  Api()
    .get("/Home/getdatacountwater/" + startDate + "/" + endDate + "/" + waterMeterId)
    .then((res) => { 
      resolve(res.data);  
    })
    .catch((err) => {
      console.error("Error fetching data:", err); // Optionally log the error as well
      reject(err);
    });
});

  },
  // sensor_get_last_month(id) {
  //   return new Promise((resolve, reject) => {
  //     Api()
  //       .post('/Home/sensor_get_last_month',{id:id})
  //       .then(res => { 
  //         console.log("##############################################");
  //         resolve(res.data)
  //       })
  //       .catch(err => reject(err))
  //   })
  // },
  // sensor_get_last_week(id) {
  //   return new Promise((resolve, reject) => {
  //     Api()
  //       .post('/Home/sensor_get_last_week',{id:id})
  //       .then(res => { 
         
  //         resolve(res.data)
  //       })
  //       .catch(err => reject(err))
  //   })
  // },
  sensor_get_dates_fixed(id,days,type) {
    return new Promise((resolve, reject) => {
      Api()
        .post('/Home/sensor_get_dates_fixed',{id:id,days:days,type:type})
        .then(res => { 
          resolve(res.data)
        })
        .catch(err => reject(err))
    })
  },
  sensor_get_dates_range(id, startDate, endDate) 
  {
    console.log("startDate "+ startDate)
    console.log("endDate "+ endDate)
    return new Promise((resolve, reject) => {
      Api()
        .post('/Home/sensor_get_dates_range', {
          id_node: id,  
          startDate: startDate,
          endDate: endDate
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => reject(err));
    });
  },

  edit_auto(state, id) {
    console.log("========================> : " + state);
    return new Promise((resolve, reject) => {
      Api()
        .post("/Home/edit_auto/", { state: state, id_node: id })
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getValue_Vanne() {
    return new Promise((resolve, reject) => {
      Api()
        .post("/Home/getValue_Vanne")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => reject(err));
    });
  },
  getvanneAPI(id) {
    return new Promise((resolve, reject) => {
      Api()
        .post("/Home/getvanneAPI", { id: id })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => //reject(err)
 
        resolve( {
          connection_status : "offline"
               })
        );
    });
  },
}
